<template>
  <v-card
    class="mx-auto fill-height"
    max-width="100%"
    flat
    :style="`border-top: 15px solid var(--v-primary-base)`"
    @click="
      $security.checkUserAccess('ViewMeetingStatistics') ? openDialog(item) : ''
    "
  >
    <v-card-text class="pt-0 pb-0">
      <v-list-item class="px-0">
        <v-list-item-content>
          <h3 class="mb-3 d-flex justify-center">{{ item.title }}</h3>
          <v-divider></v-divider>
          <v-row class="py-2" v-if="item.id === 'attendance_analysis'">
            <v-col
              cols="2"
              sm="2"
              md="3"
              lg="2"
              class="d-flex align-center justify-center"
            >
              <v-icon size="52" color="#000000">mdi-account-multiple</v-icon>
            </v-col>
            <v-col cols="10" sm="10" md="9" lg="10">
              <span
                class="description text-justify"
                v-html="$t('statistics.desAttendanceAnalysis')"
              ></span>
            </v-col>
          </v-row>
          <v-row class="py-2" v-if="item.id === 'time_allocation'">
            <v-col
              cols="2"
              sm="2"
              md="3"
              lg="2"
              class="d-flex align-center justify-center"
            >
              <v-icon size="52" color="#000000">mdi-chart-pie</v-icon>
            </v-col>
            <v-col cols="10" sm="10" md="9" lg="10">
              <span
                class="description text-justify"
                v-html="$t('statistics.desAttendanceAnalysis')"
              ></span>
            </v-col>
          </v-row>
          <v-row class="py-2" v-if="item.id === 'topic_feedbacks'">
            <v-col
              cols="2"
              sm="2"
              md="3"
              lg="2"
              class="d-flex align-center justify-center"
            >
              <v-icon size="52" color="#000000">mdi-comment-processing</v-icon>
            </v-col>
            <v-col cols="10" sm="10" md="9" lg="10">
              <span class="description text-justify">{{
                $t("statistics.lblTopicFeedbacksInst")
              }}</span>
            </v-col>
          </v-row>
        </v-list-item-content>
      </v-list-item>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "StatisticsAnalysisCard",
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isDialogOpen: false,
    };
  },
  computed: {},
  methods: {
    openDialog() {
      if (
        this.item.id === "attendance_analysis" ||
        this.item.id === "time_allocation" ||
        this.item.id === "topic_feedbacks"
      ) {
        this.$emit("openDialog", {
          isDialogOpen: true,
          item: this.item,
        });
      }
    },
  },
};
</script>

<style scoped>
.description {
  font-family: "Noto Sans JP";
  font-style: normal;
  font-weight: 400;
  font-size: 14px !important;
  line-height: 21px;
  color: #000000 !important;
}
::v-deep .surveydates {
  font-size: smaller !important;
  color: gray;
}

.title-overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  line-height: 1.5 !important;
}
</style>
